/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/explorable-exercise/v0.ts
 */

import { createValidator } from '../../helpers/validator';
export var ExplorableExerciseV0Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    },
    language: {
      type: 'string',
      enum: ['r', 'python', 'revo', 'sql', 'shell', 'scala', 'julia', 'containers']
    },
    runtime_config: {
      type: 'string'
    },
    question: {
      type: 'string',
      default: ''
    },
    pre_exercise_code: {
      type: 'string',
      default: ''
    },
    possible_answers: {
      type: 'array',
      items: {
        type: 'string'
      }
    },
    sct: {
      type: 'string',
      default: ''
    }
  },
  required: ['title', 'xp', 'course_id', 'chapter_id', 'assignment', 'hint', 'language', 'pre_exercise_code', 'possible_answers', 'sct'],
  definitions: {}
};
export var isValidExplorableExerciseV0 = createValidator(ExplorableExerciseV0Schema);
export var ExplorableExerciseV0Definition = {
  schema: ExplorableExerciseV0Schema,
  validate: isValidExplorableExerciseV0
};